import { StyleSheet } from 'react-native';
import { CELEBRATION_COLORS } from '../../constants/celebrations.constants';

export type PlayerLevelPillSize = 'sm' | 'md';

/**
 * Reuses the XpHeaderCluster pill exactly (purple fill, dark ink, 800-weight micro-type, and
 * the SURFACE-colored ring-out that punches the pill off whatever it overlaps). Design-system
 * constants, not theme-derived, so a peer's level reads the same in light and dark.
 * `sm` is for dense leaderboard rows; `md` matches the header's scale.
 */
export const getPlayerLevelPillStyles = (size: PlayerLevelPillSize) =>
  StyleSheet.create({
    pill: {
      alignSelf: 'flex-start',
      backgroundColor: CELEBRATION_COLORS.PURPLE,
      borderRadius: 999,
      paddingVertical: size === 'sm' ? 0 : 1,
      paddingHorizontal: size === 'sm' ? 5 : 6,
      borderWidth: 1.5,
      borderColor: CELEBRATION_COLORS.SURFACE,
    },
    pillText: {
      fontSize: size === 'sm' ? 8 : 9,
      fontWeight: '800',
      color: CELEBRATION_COLORS.INK,
    },
  });
